/*
 * @Desc: 文件描述
 * @Author: simbawu
 * @Date: 2019-01-21 15:19:10
 * @LastEditors: jiayi zhu
 * @LastEditTime: 2021-02-04 15:23:25
 */
export default {
  /**
   * @name 获取评测题接口
   * @returns product_id 产品ID
   */
  getWisdomSurvey(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/v2/wisdom/evaluations',
      params
    );
  },
  postWisdomOrderCode(params) {
    return this.http(
      'api',
      'post',
      '/shop-interface/v1/promotion/exchange_redeem_code',
      params
    );
  },
  /**
   * @name 提交测评题
   * @returns Object app_key、sku
   */
  postSurveyAnswers(params) {
    return this.http(
      'Columbus',
      'post',
      '/api/v2/wisdom/evaluations',
      params
    );
  },
  /**
   * @name 获取每日营养素分析接口
   * @returns Object
   */
  getDailyNuturitionAnalysis(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/gensci/reports/diet_report',
      params
    );
  },
  /**
   * @name 获取金赛食谱列表
   * @returns Object
   */
  getGensciRecipeList(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/gensci/meal_plan/weekly',
      params
    );
  },
  /**
   * @name 获取NPS详情
   * @returns Object
   */
  getNpsDetail(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/v1/nps/user_surveys',
      params
    );
  },
  /**
   * @name 提交NPS问卷
   * @returns Object
   */
  postNpsAnswers(params) {
    return this.http(
      'Columbus',
      'post',
      '/api/v1/nps/user_surveys',
      params
    );
  },
  /**
   * @Desc: 获取便便记录评测题
   * @Author: simbawu
   */
  getColumbusPooEvaluationQuestions(params) {
    return this.http(
      'Columbus',
      'get',
      '/api/v3/poo/evaluation_questions',
      params
    );
  },
  getUserDetail() {
    return this.http(
      'api',
      'get',
      '/app-interface/v1/user/user_detail'
    );
  }
};
